import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/**
 * 添加饭店接口
 * @returns {AxiosPromise}
 */
export function addRestaurant(data) {
  return request({
    url: `${baseURL.businessApi}/add_restaurant`,
    method: 'post',
    data: data
  })
}

/**
 * 修改饭店接口
 * @returns {AxiosPromise}
 */
export function editRestaurant(data) {
  return request({
    url: `${baseURL.businessApi}/edit_restaurant`,
    method: 'post',
    data: data
  })
}


/**
 * 查询饭店接口
 * @returns {AxiosPromise}
 */
export function getRestaurantList(query) {
  return request({
    url: `${baseURL.businessApi}/select_restaurant`,
    method: 'get',
    params: query
  })
}

/**
 * 根据id查询饭店接口
 * @returns {AxiosPromise}
 */
export function getRestaurantById(id) {
  return request({
    url: `${baseURL.businessApi}/select_restaurant/${id}`,
    method: 'get'
  })
}

/**
 * 删除饭店接口
 * @returns {AxiosPromise}
 */
export function deleteRestaurantBatch(ids) {
  return request({
    url: `${baseURL.businessApi}/del_restaurant/batch`,
    method: 'post',
    data: ids
  })
}


/**
 * 查询饭店优惠券购买审核记录接口
 * @returns {AxiosPromise}
 */
export function getRestaurantCouponRecordList(query) {
  return request({
    url: `${baseURL.businessApi}/select_restaurantCouponRecord`,
    method: 'get',
    params: query
  })
}


/**
 * 查询饭店优惠券购买审核信息接口
 * @returns {AxiosPromise}
 */
export function getRestaurantUseCouponList(query) {
  return request({
    url: `${baseURL.businessApi}/select_restaurantUseCoupon`,
    method: 'get',
    params: query
  })
}


/**
 * 查询饭店优惠券购买审核信息发送优惠券接口
 * @returns {AxiosPromise}
 */
export function sendCouponBatch(ids) {
  return request({
    url: `${baseURL.businessApi}/send_restaurantUseCoupon/batch`,
    method: 'post',
    data: ids
  })
}

/**
 * 根据优惠券id查询是否有饭店使用该优惠券
 * @returns {AxiosPromise}
 */
export function isRestaurantCoupon(id) {
  return request({
    url: `${baseURL.businessApi}/is_restaurantCoupon/${id}`,
    method: 'get',
  })
}

